<div class="flex-column full-height">
  <vdw-tabs-menu-card
    icon="library-blue"
    [title]="'DESIGN_LIBRARY.LIBRARY.DESIGNS_LIBRARY' | bmsTranslate"
    [hasPermissionToEdit]="hasEditPermission"
    [canShowBackButton]="shouldShowBackButton()"
    [canShowCustomSettings]="hasSettingsPermission"
    (settingsEvent)="navigateToPage(urlToNavigateToSettings)"
  >
    <mat-form-field class="view-mode-field no-subscript">
      <mat-select (selectionChange)="onViewModeFilterChange($event)" [value]="viewModes[0]">
        <mat-option *ngFor="let viewMode of viewModes" [value]="viewMode" [attr.value]="viewMode">
          {{ 'DESIGN_LIBRARY.LIBRARY.VIEW_MODES.' + viewMode | bmsTranslate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </vdw-tabs-menu-card>
  <mat-card class="flex-column full-height full-width no-margin">
    <mat-sidenav-container [hasBackdrop]="false" class="sidebar-container">
      <mat-sidenav #sidenav class="drawing-detail-container sidebar-large" mode="over" position="end" [fixedInViewport]="false" [fixedTopGap]="0" [autoFocus]="false" disableClose>
        <app-drawing-library-details
          #drawingLibraryDetailsComponent
          fxFill
          [drawingId]="selectedDrawing?.drawing.id"
          [drawingState]="selectedDrawingState"
          (drawingDeleted)="onDrawingDeleted($event)"
          (drawingCanceled)="onDrawingCanceled()"
          (drawingUpdated)="onDrawingUpdated($event)"
          (drawingReplaced)="onDrawingReplaced($event)"
        >
        </app-drawing-library-details>
      </mat-sidenav>

      <mat-sidenav-content>
        <div class="drawing-library-content flex-column full-width full-height">
          <div class="flex-row full-width">
            <div class="toolbar actions flex-row gap-16">
              <ng-container *ngIf="hasEditPermission">
                <input
                  appDataCy="design-files"
                  #drawingImageInput
                  fxHide
                  multiple
                  type="file"
                  [attr.accept]="allowedFileExtensionForFiles"
                  (change)="onDrawingFileChange($event.target.files); drawingImageInput.value = ''"
                />
                <button
                  mat-icon-button
                  appDataCy="add-designs"
                  class="mat-icon-action-button-lg-with-border"
                  (click)="drawingImageInput.click()"
                  [matTooltip]="'GENERAL.ACTIONS.CREATE_NEW' | bmsTranslate"
                >
                  <mat-icon svgIcon="add"></mat-icon>
                </button>

                <button
                  *ngIf="!isModeTable()"
                  mat-icon-button
                  appDataCy="selectMultiple"
                  class="mat-icon-action-button-lg-with-border"
                  (click)="toggleSelectMultipleButton()"
                  [matTooltip]="'GENERAL.ACTIONS.SELECT_MULTIPLE' | bmsTranslate"
                  [class.select-mode-active]="selectMultipleButtonActive"
                  [class.select-mode-inactive]="!selectMultipleButtonActive"
                >
                  <mat-icon svgIcon="select"></mat-icon>
                </button>

                <button
                  mat-icon-button
                  appDataCy="delete"
                  class="mat-icon-action-button-lg-with-border delete"
                  [disabled]="!hasDrawingsToBeDeleted()"
                  [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate"
                  (click)="removeConfirmation()"
                >
                  <mat-icon svgIcon="trash"></mat-icon>
                </button>

                <button
                  *ngIf="isModeTable()"
                  mat-icon-button
                  class="mat-icon-action-button-lg-with-border"
                  (click)="isExporting = true"
                  [matTooltip]="'AGGRID.EXPORT' | bmsTranslate"
                  [disabled]="isExporting"
                >
                  <mat-icon svgIcon="export"></mat-icon>
                </button>
              </ng-container>
            </div>
            <div class="toolbar actions flex-row full-width min-width-0" *ngIf="canUseCustomFilterComponent()">
              <app-search-filters
                #searchFilters
                class="full-width min-width-0"
                [searchFilters]="advancedSearchFilters"
                [commercialUnit]="defaultUnit"
                [showFiltersFromRightToLeft]="true"
                (searchFiltersChanged)="updateFilteredDrawings()"
                (showAdvancedSearch)="showAdvancedSearch()"
              ></app-search-filters>

              <vdw-filter #nameFilter icon="filter" fxLayoutAlign="center" (filteredTextChanged)="onNameFilterChange($event)" (filterIconClicked)="showAdvancedSearch()"> </vdw-filter>
            </div>
          </div>

          <app-drawing-library-thumbnails
            *ngIf="isModeThumbnails()"
            #drawingLibraryThumbnailsComponent
            [advancedSearchFilters]="advancedSearchFilters"
            [viewMode]="selectedDrawingLibraryViewMode"
            (drawingSelected)="onDrawingSelected($event)"
            [allowSelectMultipleDrawings]="selectMultipleButtonActive"
            [selectedDrawingId]="selectedDrawingId"
          >
          </app-drawing-library-thumbnails>

          <app-drawing-library-listview
            *ngIf="isModeTable()"
            #drawingLibraryNewListViewComponent
            class="full-height full-width"
            [isProductionSchedule]="false"
            [hideMissingDesigns]="true"
            [showConfigurations]="true"
            (drawingSelected)="onDrawingSelected($event)"
            [isExporting]="isExporting"
            fxFlex="2 0 0px"
            (advancedSearchFiltersChange)="updateAdvancedSearchFilters($event)"
            (exportComplete)="exportComplete()"
          ></app-drawing-library-listview>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-card>
</div>
